export function getImageUrl(img,isMini){
    return `/server/img/userimage/${img.id}?isMini=${isMini?'true':'false'}`
}